
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 16C6.17879 16 2.71351 13.8957 0.15649 10.4777C-0.0521632 10.1977 -0.0521632 9.80645 0.15649 9.52642C2.71351 6.10432 6.17879 4 10 4C13.8212 4 17.2865 6.10432 19.8435 9.52231C20.0522 9.80233 20.0522 10.1935 19.8435 10.4736C17.2865 13.8957 13.8212 16 10 16ZM10.2741 5.77488C7.73755 5.61428 5.64284 7.7186 5.80239 10.2759C5.93331 12.3844 7.63118 14.0933 9.72589 14.2251C12.2625 14.3857 14.3572 12.2814 14.1976 9.72409C14.0626 7.61977 12.3647 5.91078 10.2741 5.77488ZM10.1473 7.72684C8.78081 7.64036 7.65163 8.77282 7.74164 10.1482C7.81119 11.2848 8.72763 12.2032 9.85681 12.2773C11.2233 12.3638 12.3525 11.2313 12.2625 9.85587C12.1888 8.71517 11.2724 7.79684 10.1473 7.72684Z"}})])
          )
        }
      }
    